import { useNavigate } from 'react-router';
import { OrganizationApi, ToastStateHandler, isSubscriptionError } from '../../../api';
import { CreateHolidayDto } from '../../../commonTypes/organization.types';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const useHttpPostHoliday = () => {
    const { t } = useTranslation('newNotifications');
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const toastHandler = useContainer(ToastStateHandler);
    const navigate = useNavigate();

    const exec = (body: CreateHolidayDto) => {
        const { exec, abort } = organizationApi.postHoliday({
            body,
            onSuccess: _ => {
                toastHandler.push('success', t('holiday.createHolidayTitle'), t('holiday.createHolidayMessage_Success'));
                navigate(`/holidays/${body.date.getFullYear().toString()}`);
            },
            onError: (errorMessage, errorCode) => {
                if (isSubscriptionError(errorCode, errorMessage)) {
                    toastHandler.push('error', t('holiday.createHolidayTitle'), errorMessage);
                } else {
                    toastHandler.push('error', t('holiday.createHolidayTitle'), t('holiday.createHolidayMessage_Failed'));
                }
            },
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpPostHoliday;
